export const parseSecondsToHoursAndMinutes = (seconds: number | string) => {
  if (typeof seconds === 'string') seconds = parseInt(seconds)
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if(minutes === 0 && hours === 0 && seconds > 0) return '1m'
  if(hours === 0) return `${minutes}m`
  const hh = String(hours)
  const mm = String(minutes).padStart(2, '0')
  return `${hh}:${mm}h`
}

export const parseToShortDate = (date: string) => {
  return new Date(date).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
  })
}

export const getDayOfMonth = (date: Date) => {
  return new Date(date).getDate()
}

export const getMonthName = (date: Date, locale: string) => {
  return new Date(date).toLocaleString(locale, { month: 'short' })
}

export const getHoursAndMinutes = (date: Date, locale: string) => {
  return new Date(date).toLocaleTimeString(locale, {hour: '2-digit', minute:'2-digit'})
}

export const getDateTimeInISO8601 = (dateString: string | Date) => {
  const date = new Date(dateString)
  const YYYY = date.getUTCFullYear()
  const MM = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-indexed in JavaScript
  const DD = String(date.getUTCDate()).padStart(2, '0')
  const hh = String(date.getUTCHours()).padStart(2, '0')
  const mm = String(date.getUTCMinutes()).padStart(2, '0')
  const ss = String(date.getUTCSeconds()).padStart(2, '0')

  return `${YYYY}${MM}${DD}T${hh}${mm}${ss}Z`
}


export const getICalFile = (title: string, location: string, description: string, startDate: Date, endDate: Date, link: string): string => {
  // Escape special characters and remove line breaks
  const escapedDescription = description
    .replace(/[\n\r]/g, '\\n')
    .replace(/[,;]/g, '\\$&')
  const escapedTitle = title.replace(/[,;]/g, '\\$&')
  const escapedLocation = location.replace(/[,;]/g, '\\$&')

  const icsMSG =
`BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Zrive//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:${Date.now()}@zrive.com
DTSTAMP:${getDateTimeInISO8601(new Date())}
DTSTART:${getDateTimeInISO8601(startDate)}
DTEND:${getDateTimeInISO8601(endDate)}
SUMMARY:${escapedTitle}
DESCRIPTION:${escapedDescription}\\n\\nMore info: ${link}
LOCATION:${escapedLocation}
STATUS:CONFIRMED
END:VEVENT
END:VCALENDAR`

  // Properly encode the calendar data
  const encodedIcsMSG = encodeURIComponent(icsMSG.trim())
  return `data:text/calendar;charset=utf8,${encodedIcsMSG}`
}

/**
 * Returns the amount of days in the past a given date is compared to current date.
 * If the date is today, it returns 0.
 * It ignores hours, minutes and seconds.
 * @param pastDate
 * @returns number
 */
export const getDaysSinceDate = (pastDate: Date) => {
  // Ensure the input is a Date object
  const inputDate = pastDate instanceof Date ? pastDate : new Date(pastDate)
  if(inputDate instanceof Date && isNaN(inputDate.getTime())) {
    throw new Error('Invalid date format.')
  }

  // Create dates using only the year, month, and day components
  const today = new Date()
  const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate())

  const comparisonDateWithoutTime = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  )

  // Calculate the difference in milliseconds
  const timeDifference = todayWithoutTime.getTime() - comparisonDateWithoutTime.getTime()

  // Convert milliseconds to days
  const daysDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24))

  // Return 0 if the date is today, otherwise return positive days
  return Math.max(0, daysDifference)
}
